import { Component, OnInit, Optional, Inject } from '@angular/core';
import { EditDialogsParametersService } from './edit-dialogs-parameters.service';
import { DialogsAlertComponent } from '../../../../../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-dialogs-parameters',
  templateUrl: './edit-dialogs-parameters.component.html',
  styleUrls: ['./edit-dialogs-parameters.component.scss']
})
export class EditDialogsParametersComponent implements OnInit {

  /** Subscripción para el guardado de un parametro */
  $guardar!: Subscription;

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%'};

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public editDialogsParametersService: EditDialogsParametersService,
              @Optional() private dialogRef: MatDialogRef<EditDialogsParametersComponent>,
              private translateService: TranslateService,
              private dialog: MatDialog) { this.editDialogsParametersService.build(); }

  ngOnInit() {
    this.editDialogsParametersService.init(this.data).subscribe(result => {
      this.loading = false;
    });
  }

  /**
  * @description
  * Guardar el Parameters
  */
  guardar() {
    this.loading = true;
    this.$guardar = this.editDialogsParametersService.guardar().subscribe(value => {
      console.log(value);
      // -2: El número del parameter está ausente
      // -1: El número del parameter ya existe
      // false: Error al guardar
      if (value === -1 || value === false || value === -2) {
        this.errorParameters('WARNINGS.error_nuevo');
      }
      this.loading = false;
    }, error => {
      console.log(error);
      this.errorParameters('WARNINGS.error_nuevo');
      this.loading = false;
    });
  }

  /**
  * @description
  * Cierra el dialog parameters
  */
  aceptar() {
    this.dialogRef.close(true);
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  deshabilitar(){
    let parametro = this.editDialogsParametersService.parameters;
    let original = this.editDialogsParametersService.originalParameters;
    return this.editDialogsParametersService.compare(parametro, original);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorParameters(error: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

}
